import React from "react";
import PropTypes from "prop-types";
import { PhoneNumberField } from "./PhoneNumber";
import ErrorAlert from "../Alert/ErrorAlert";

const CallError = ({
  callStatus,
  number,
  onChangeNumber,
  onChangeSaveNumber,
}) => (
  <React.Fragment>
    <div>
      <PhoneNumberField
        number={number}
        onChangeNumber={onChangeNumber}
        onChangeSaveNumber={onChangeSaveNumber}
      />
    </div>

    <ErrorAlert block>{callStatus}</ErrorAlert>
  </React.Fragment>
);

CallError.propTypes = {
  callStatus: PropTypes.string.isRequired,
  number: PropTypes.string.isRequired,
  onChangeNumber: PropTypes.func.isRequired,
  onChangeSaveNumber: PropTypes.func.isRequired,
};

export default CallError;
